/**
 * Created by calhosh on 1/22/2025
 */
import {GET_AICHATBOT_INTEGRATION_PARAMETERS, SET_AICHATBOT_INTEGRATION_PARAMETERS} from '../actiontypes';

export function setAIChatBotIntegrationParameters(payload) {
	return {
		type: SET_AICHATBOT_INTEGRATION_PARAMETERS,
		payload
	};
}

export function getAIChatBotIntegrationParameters(url, payload) {
	return {
		type: GET_AICHATBOT_INTEGRATION_PARAMETERS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		data: payload
	};
}
